import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const GateView = styled.div`
	flex: 1;
	min-height: 0;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	overscroll-behavior: contain;

	@media (max-width: 760px) {
		align-items: flex-start;
		justify-content: flex-start;
		padding: 0;
	}
`;

export const GateLayout = styled.div`
	width: min(920px, 100%);
	display: grid;
	grid-template-columns: minmax(250px, 0.74fr) minmax(360px, 1.26fr);
	border: 1px solid rgba(255, 255, 255, 0.14);
	border-radius: 18px;
	overflow: hidden;
	background:
		radial-gradient(circle at 74% 0%, rgba(255, 77, 242, 0.13), transparent 34%),
		rgba(18, 7, 20, 0.96);
	box-shadow:
		0 34px 110px rgba(0, 0, 0, 0.72),
		0 0 36px rgba(255, 77, 242, 0.12);

	@media (max-width: 760px) {
		width: 100%;
		min-height: 100%;
		border: none;
		border-radius: 0;
		box-shadow: none;
		grid-template-columns: 1fr;
	}
`;

export const GateHero = styled.section`
	position: relative;
	min-height: 420px;
	background: #09050c;
	overflow: hidden;

	&::after {
		content: '';
		position: absolute;
		inset: 0;
		background:
			linear-gradient(180deg, transparent 42%, rgba(0, 0, 0, 0.82) 100%),
			linear-gradient(90deg, transparent 72%, rgba(18, 7, 20, 0.72) 100%);
	}

	img {
		width: 100%;
		height: 100%;
		min-height: 420px;
		object-fit: cover;
		object-position: center top;
		display: block;
	}

	@media (max-width: 760px) {
		min-height: unset;
		height: 132px;

		img {
			width: 100%;
			height: 132px;
			min-height: unset;
			max-height: 132px;
		}

		&::after {
			background: linear-gradient(180deg, transparent 20%, rgba(0, 0, 0, 0.84) 100%);
		}
	}
`;

export const GateHeroCopy = styled.div`
	position: absolute;
	left: 26px;
	right: 26px;
	bottom: 26px;
	z-index: 1;

	h2 {
		margin: 0 0 10px;
		color: ${THEME.gold};
		font-family: ${THEME.fontDisplay};
		font-size: 1.55rem;
		line-height: 1;
		text-shadow: 0 0 14px rgba(255, 211, 107, 0.34);
	}

	p {
		margin: 0;
		max-width: 260px;
		color: rgba(255, 255, 255, 0.94);
		font-size: 0.84rem;
		line-height: 1.35;
	}

	@media (max-width: 760px) {
		left: 16px;
		right: 16px;
		bottom: 12px;

		h2 {
			margin-bottom: 6px;
			font-size: 1.15rem;
		}

		p {
			font-size: 0.75rem;
			line-height: 1.3;
		}
	}
`;

export const GateCard = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 40px 36px;
	gap: 16px;

	@media (max-width: 760px) {
		justify-content: flex-start;
		padding: 24px 20px calc(24px + env(safe-area-inset-bottom, 0px));
	}
`;

export const GateTitle = styled.h2`
	margin: 0;
	font-family: ${THEME.fontDisplay};
	font-size: 1.65rem;
	line-height: 1.15;
	color: ${THEME.text};
`;

export const GateDescription = styled.p`
	margin: 0;
	color: rgba(216, 189, 228, 0.88);
	font-size: 0.95rem;
	line-height: 1.5;
`;

export const GateActions = styled.div`
	display: grid;
	gap: 12px;
	margin-top: 8px;
`;

export const GatePrimaryButton = styled.button`
	min-height: 48px;
	border: 0;
	border-radius: 9px;
	color: #fff;
	background: linear-gradient(135deg, rgba(176, 38, 255, 0.92), rgba(255, 77, 242, 0.74));
	font-weight: 900;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	box-shadow: 0 0 26px rgba(255, 77, 242, 0.2);
	cursor: pointer;
`;

export const GateSecondaryButton = styled.button`
	min-height: 44px;
	border: 1px solid rgba(255, 255, 255, 0.18);
	border-radius: 9px;
	color: rgba(255, 247, 255, 0.88);
	background: rgba(255, 255, 255, 0.04);
	font-weight: 700;
	cursor: pointer;

	&:hover {
		border-color: rgba(255, 211, 107, 0.38);
		color: ${THEME.gold};
	}
`;
